import defaultCategoryImage from 'img/default-challenge-image.jpg';

function GetCompetitionImageUrl(competition) {
	return competition.leaderboard?.banner?.url || competition.competition?.banner?.url || defaultCategoryImage
}

export const getCompetitionImageUrl = GetCompetitionImageUrl;